import { useTranslation } from 'react-i18next';

export const useText = (key: string): string => {
  const { t } = useTranslation();
  return t(key);
};

export default useText;
